module.exports = __webpack_public_path__ + "fonts/fontello.56f84d72.eot";